import { getHighestRating, ratingWeightage, sortData, } from "@domains/utils/sort";
import * as moment from "moment";
export const applySortFilter = (data, filterData, sort) => {
    let newData = JSON.parse(JSON.stringify(data));
    if ((filterData === null || filterData === void 0 ? void 0 : filterData.length) > 0) {
        newData = filter(newData, filterData);
    }
    if (sort) {
        newData = sortData(sort, newData);
    }
    return newData;
};
export const applySortFilterOrderbook = (data, filterData, sort) => {
    let newData = JSON.parse(JSON.stringify(data));
    if (filterData.length > 0) {
        newData = filterForOrderBook(newData, filterData);
    }
    if (sort) {
        newData = sortData(sort, newData);
    }
    return newData;
};
export default function filter(data, filterState) {
    return [...data].filter((e) => {
        return filterState.some((f) => {
            let fVal = typeof f.key === "string"
                ? e[f.key]
                : f.key.reduce((a, k) => a[k], e);
            if (f.type && f.type === "Date") {
                return filterDataAccordingToDate(fVal, f.value);
            }
            else if (f.type && f.type === "lesserThan") {
                return typeof f.key === "string"
                    ? Number(e[f.key]) < Number(f.value)
                    : null;
            }
            else if (f.type && f.type === "greaterThan") {
                return typeof f.key === "string"
                    ? Number(e[f.key]) > Number(f.value)
                    : null;
            }
            else if (f.type && f.type === "between") {
                const bounds = f.value.split(",");
                return typeof f.key === "string"
                    ? Number(e[f.key]) >= Number(bounds[0]) &&
                        Number(e[f.key]) <= Number(bounds[1])
                    : null;
            }
            else if (f.type && f.type === "Rating") {
                return typeof f.key === "string"
                    ? ratingWeightage[getHighestRating(e[f.key])] < f.value
                    : null;
            }
            else {
                return Array.isArray(f.value)
                    ? f.value.length === 0 || f.value.indexOf(fVal) > -1
                    : fVal === f.value;
            }
        });
    });
}
export function filterForOrderBook(data, filterState) {
    let trsTyp = [];
    let prdTyp = [];
    filterState.forEach((x, i) => {
        var _a;
        if (i == 0) {
            prdTyp.push(x);
            // } else if (x.key == "prdCode" || x.key == "prCd") {
        }
        else if (((_a = prdTyp[0]) === null || _a === void 0 ? void 0 : _a.key) == x.key) {
            prdTyp.push(x);
        }
        else {
            trsTyp.push(x);
        }
    });
    let productsData = (prdTyp === null || prdTyp === void 0 ? void 0 : prdTyp.length) > 0 ? filter(data, prdTyp) : data;
    if ((trsTyp === null || trsTyp === void 0 ? void 0 : trsTyp.length) > 0) {
        return filter(productsData, trsTyp);
    }
    return productsData;
}
const filterDataAccordingToDate = (fVal, periodVal) => {
    if (fVal && periodVal) {
        let splitPeriod = periodVal.split("to");
        return moment(fVal).isBetween(splitPeriod[0], splitPeriod[1]);
    }
};
export const claculatePeriod = (period, format, CustomDateFilter, isNext) => {
    // "DD-MMM-YYYY"
    if (CustomDateFilter) {
        return period;
    }
    else if (period === "ThisWeek") {
        return `${moment().startOf("week").format(format)}to${moment().format(format)}`;
    }
    else if (period === "ThisMonth") {
        return `${moment().startOf("month").format(format)}to${moment()
            .endOf("month")
            .format(format)}`;
    }
    else if (period === "LastMonth") {
        return `${moment()
            .subtract(1, "months")
            .startOf("month")
            .format(format)}to${moment()
            .subtract(1, "months")
            .endOf("month")
            .format(format)}`;
    }
    else if (period === "ThisQuarter") {
        return `${moment()
            .quarter(moment().quarter())
            .startOf("quarter")
            .format(format)}to${moment()
            .quarter(moment().quarter())
            .endOf("quarter")
            .format(format)}`;
    }
    else if (isNext) {
        let splitPeriod = period.split("-");
        return `${moment().format(format)}to${moment()
            .add(splitPeriod[1], "months")
            .format(format)}`;
    }
    else {
        let splitPeriod = period.split("-");
        return `${moment()
            .subtract(splitPeriod[1], "months")
            .format(format)}to${moment().format(format)}`;
    }
};
